import {

    characterPortfolioItems,

    portfolioCardHref,

} from './characterDesignPortfolioData'

import {

    productDesignCaseHref,

    productPortfolioItems,

} from './productDesignData'

import {

    industrialDesignCaseHref,

    industrialPortfolioItems,

} from './industrialDesignData'

import { sortPortfolioByYear } from './portfolioYearSort'



export const CODAM_DESIGN_PORTFOLIO_PATH = '/codam-design/portfolio'



export const codamDesignPortfolioFilters = [

    { id: 'all', label: '전체 프로젝트' },

    { id: 'character', label: '캐릭터 디자인' },

    { id: 'industrial', label: '산업 디자인' },

    { id: 'product', label: '제품 디자인' },

]



const disciplineLabels = {

    character: '캐릭터 디자인',

    industrial: '산업 디자인',

    product: '제품 디자인',

}



/**

 * @param {'character' | 'industrial' | 'product'} filterId

 * @param {{ slug?: string, linkSlug?: string, detailHash?: string, comingSoon?: boolean }} item

 */

function disciplineHref(filterId, item) {

    if (item.comingSoon) return undefined

    if (filterId === 'character') return portfolioCardHref(item)

    if (filterId === 'industrial' && item.slug) return industrialDesignCaseHref(item.slug)

    if (filterId === 'product' && item.slug) return productDesignCaseHref(item.slug)

    return undefined

}



/**

 * 동일 slug가 산업·제품 등 여러 분야에 있으면 카드 1장으로 합칩니다 (예: Ducati Laser).

 * @returns {typeof codamDesignPortfolioItems}

 */

function buildCodamDesignPortfolioItems() {

    /** @type {Map<string, Record<string, unknown>>} */

    const bySlug = new Map()

    /** @type {Record<string, unknown>[]} */

    const withoutSlug = []



    /** @type {Array<['character' | 'industrial' | 'product', typeof characterPortfolioItems]>} */

    const sources = [

        ['character', characterPortfolioItems],

        ['industrial', industrialPortfolioItems],

        ['product', productPortfolioItems],

    ]



    for (const [filterId, items] of sources) {

        for (const item of items) {
            if (item.comingSoon) continue

            const base = {

                ...item,

                filterId,

                category: disciplineLabels[filterId],

                href: disciplineHref(filterId, item),

            }



            if (!item.slug) {

                withoutSlug.push({

                    ...base,

                    filterIds: [filterId],

                })

                continue

            }



            const existing = bySlug.get(item.slug)

            if (!existing) {

                bySlug.set(item.slug, {

                    ...base,

                    filterIds: [filterId],

                })

                continue

            }



            const filterIds = /** @type {string[]} */ (existing.filterIds)

            if (!filterIds.includes(filterId)) {

                filterIds.push(filterId)

            }



            existing.filterIds = filterIds

            existing.category = filterIds.map((id) => disciplineLabels[id]).join(' · ')

            existing.filterId = filterIds[0]



            if (!existing.href) {

                existing.href = base.href

            }

        }

    }



    const merged = [...bySlug.values(), ...withoutSlug].map((item) => {

        const filterIds = /** @type {string[]} */ (item.filterIds ?? [item.filterId])

        const slug = /** @type {string | undefined} */ (item.slug)



        if (filterIds.length > 1 && slug && !item.comingSoon) {

            return {

                ...item,

                href: resolveCrossDisciplineHref(filterIds, slug),

            }

        }

        return item

    })



    return sortPortfolioByYear(merged)

}



/**

 * @param {string[]} filterIds

 * @param {string} slug

 */

function resolveCrossDisciplineHref(filterIds, slug) {

    if (filterIds.includes('product')) return productDesignCaseHref(slug)

    if (filterIds.includes('industrial')) return industrialDesignCaseHref(slug)

    return productDesignCaseHref(slug)

}



/** @param {string} activeFilter */

function itemMatchesPortfolioFilter(item, activeFilter) {

    if (activeFilter === 'all') return true

    const filterIds = item.filterIds ?? (item.filterId ? [item.filterId] : [])

    return filterIds.includes(activeFilter)

}



export const codamDesignPortfolioItems = buildCodamDesignPortfolioItems()



/**

 * @param {string} activeFilter

 */

export function getFilteredCodamDesignPortfolioItems(activeFilter = 'all') {

    const items =

        activeFilter === 'all'

            ? codamDesignPortfolioItems

            : codamDesignPortfolioItems.filter((item) =>

                  itemMatchesPortfolioFilter(item, activeFilter),

              )

    return sortPortfolioByYear(items)

}



/**

 * @param {{

 *   slug?: string,

 *   linkSlug?: string,

 *   detailHash?: string,

 *   comingSoon?: boolean,

 *   href?: string,

 *   filterId?: string,

 * }} item

 */

export function codamDesignPortfolioItemHref(item) {

    if (item.href) return item.href

    if (item.comingSoon) return CODAM_DESIGN_PORTFOLIO_PATH

    if (item.filterId === 'product' && item.slug) return productDesignCaseHref(item.slug)

    if (item.filterId === 'industrial' && item.slug) return industrialDesignCaseHref(item.slug)

    return portfolioCardHref(item)

}


